import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

function Mobilemenu() {
  const location = useLocation();

  const isHomeActive = location.pathname === '/' || location.pathname === '/home';
  const isProductsActive =
    location.pathname === '/shop' ||
    location.pathname.startsWith('/category/') ||
    location.pathname.startsWith('/product/');
  const isAboutActive = location.pathname === '/about';
  const isSponsorshipActive = location.pathname === '/sponsership';
  const isGalleryActive = location.pathname === '/gallery';
  const isContactActive = location.pathname === '/contact';

  return (
    <nav className="navbar-mobile">
      <ul className="navbar-nav">
        <li className="nav-item">
          <NavLink className={`nav-link${isHomeActive ? ' active' : ''}`} to="/home">
            Home
          </NavLink>
        </li>

          <li className="nav-item">
          <NavLink className={`nav-link${isAboutActive ? ' active' : ''}`} to="/about">
            About Us
          </NavLink>
        </li>   


        <li className="nav-item">
          <NavLink
            className={`nav-link${isProductsActive ? ' active' : ''}`}
            to="/shop"
          >
            Products
          </NavLink>
        </li>

         <li className="nav-item">
          <NavLink
            className={`nav-link${isProductsActive ? ' active' : ''}`}
            to="/gallery"
          >
            Gallery
          </NavLink>
        </li>




     
        <li className="nav-item">
          <NavLink
            className={`nav-link${isContactActive ? ' active' : ''}`}
            to="/contact"
          >
            Contact Us
          </NavLink>
        </li>
    
      </ul>
    </nav>
  );
}

export default Mobilemenu;
